import { Link } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { apiGet } from '../lib/api'
import { formatDateTime } from '../lib/format'
import { pagePath } from '../lib/pages'
import { schwereStufe, schwereText } from '../lib/syslog'
import type { SyslogPage } from '../lib/types'
import { StatusBadge } from './Status'

/**
 * Die letzten Syslog-Meldungen eines Geräts. Ohne Meldungen in den letzten
 * sieben Tagen bleibt die Karte weg – dann sammelt der Kunde kein Syslog oder
 * das Gerät sendet keins.
 */
export function SyslogKarte({ deviceId, customerSlug }: { deviceId: string; customerSlug: string | null }) {
  const daten = useQuery({
    queryKey: ['device-syslog', deviceId],
    queryFn: ({ signal }) => {
      const bis = new Date()
      const von = new Date(bis.getTime() - 7 * 24 * 3_600_000)
      const p = new URLSearchParams({ geraet: deviceId, limit: '10', von: von.toISOString(), bis: bis.toISOString() })
      return apiGet<SyslogPage>(`/syslog?${p.toString()}`, signal)
    },
    refetchInterval: 60_000,
  })
  const zeilen = daten.data?.eintraege ?? []
  if (zeilen.length === 0) return null

  return (
    <section className="card">
      <div className="card-head">
        <h2 className="card-title">Syslog</h2>
        <Link to={pagePath('syslog', customerSlug)} search={{ geraet: deviceId } as never}>
          Alle Meldungen
        </Link>
      </div>
      <table className="data">
        <tbody>
          {zeilen.map((z) => (
            <tr key={z.id}>
              <td className="mono" style={{ fontSize: 12, whiteSpace: 'nowrap', width: 150 }}>
                {formatDateTime(z.time)}
              </td>
              <td style={{ width: 100 }}>
                <StatusBadge state={schwereStufe(z.severity)} label={schwereText(z.severity)} />
              </td>
              <td className="mono" style={{ fontSize: 12, wordBreak: 'break-word' }}>
                {z.app ? <span className="muted">{z.app}: </span> : null}
                {z.message}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
